/**
 * AAL2 read-gate panel for the My Leave screen.
 *
 * Mirrors `my_pay_step_up_panel.tsx` exactly (same single-CTA shape: only a
 * "try again" action). Deliberately NOT shared with MyPayStepUpPanel — the
 * copy is my-leave-specific (`wp.my_leave.step_up.*` keys), and both are thin
 * wrappers around the same shared mechanics in `lib/auth/step_up.ts`. See
 * `my_pay_step_up_panel.tsx`'s module docblock for the full rationale on
 * intentional presentation duplication.
 *
 * ── No "set up 2FA" link, deliberately ─────────────────────────────────────
 *
 * This panel used to lead with a CTA to `${resolveLedgerWebUrl()}
 * /settings/security` — sending a WagePro employee to the LEDGER dashboard to
 * enrol 2FA before they could view their own leave balances/requests.
 * WagePro is its own product (CLAUDE.md § Branding) and has no
 * TOTP-enrolment screen of its own, so that link was the only route out of
 * this state and it left the product. It is gone, same rationale and same
 * removal as `MyPayStepUpPanel`'s (see that file's module docblock for the
 * full history) — "try again" is the only action, and the copy tells the
 * reader to contact their administrator instead.
 */
import { useTranslation } from '@mukil/i18n';
import { Button, GlassCard } from '@jumpstone/ui-react';
import { restartSignIn } from '../../lib/auth/step_up.js';

export function MyLeaveStepUpPanel(): React.JSX.Element {
  const { t } = useTranslation('wp');

  return (
    <GlassCard variant="accent" className="rounded-2xl p-5">
      <h2 className="font-bold mb-1.5">{t('my_leave.step_up.title')}</h2>
      <p className="text-[13.5px] text-[color:var(--ink-muted)] mb-3.5">
        {t('my_leave.step_up.description')}
      </p>
      <div className="flex gap-2">
        <Button
          variant="primary"
          onClick={() => {
            restartSignIn();
          }}
        >
          {t('my_leave.step_up.retry_cta')}
        </Button>
      </div>
    </GlassCard>
  );
}
